// De-Para de enums de produto (valor da base -> label legivel ao usuario).
// Entradas vazias ("") e "OUTRO" nao entram nos mapas: sao tratadas em resolveEnumLabel.

export const AreaAplicacaoLabels = {
  ROSTO: "Rosto",
  OLHOS: "Olhos",
  CORPO: "Corpo",
  MAOS: "Mãos",
  PES: "Pés",
  CABELO: "Cabelo",
  AXILA: "Axila",
  BOCA: "Boca",
  INTIMO: "Íntimo",
};

export const UnidadeEmbalagemLabels = {
  CAIXA: "Caixa",
  FRASCO: "Frasco",
  BISNAGA: "Bisnaga",
  LATA: "Lata",
  POTE: "Pote",
  BLISTER: "Blister",
  ENVELOPE: "Envelope",
  ROLO: "Rolo",
  PACOTE: "Pacote",
  UN: "Un",
};

export const UnidadeConteudoLabels = {
  COMPRIMIDO: "comprimido",
  CAPSULA: "cápsula",
  DRAGEA: "drágea",
  SACHE: "sachê",
  PASTILHA: "pastilha",
  ML: "ml",
  G: "g",
  KG: "kg",
  MG: "mg",
  MCG: "mcg",
  UI: "UI",
  UN: "un",
};

export const ApresentacaoLabels = {
  EM_COMPRIMIDO: "Em Comprimido",
  EM_COMPRIMIDO_REVESTIDO: "Em Comprimido Revestido",
  EM_CAPSULA: "Em Cápsula",
  EM_CAPSULA_SOFTGEL: "Em Cápsula Softgel",
  EM_DRAGEA: "Em Drágea",
  EM_XAROPE: "Em Xarope",
  EM_SUSPENSAO: "Em Suspensão",
  EM_SOLUCAO: "Em Solução",
  EM_GOTAS: "Em Gotas",
  EM_POMADA: "Em Pomada",
  EM_CREME: "Em Creme",
  EM_GEL: "Em Gel",
  EM_LOCAO: "Em Loção",
  EM_SPRAY: "Em Spray",
  EM_AEROSOL: "Em Aerosol",
  EM_AMPOLA: "Em Ampola",
  EM_SACHE: "Em Sachê",
  EM_PO: "Em Pó",
  EM_ADESIVO: "Em Adesivo",
  EM_OVULO: "Em Óvulo",
  EM_SUPOSITORIO: "Em Supositório",
  EM_COLIRIO: "Em Colírio",
  EM_PASTILHA: "Em Pastilha",
  EM_GRANULADO: "Em Granulado",
  EM_EMULSAO: "Em Emulsão",
  EM_BARRA: "Em Barra",
  EM_LENCO: "Em Lenço",
};

export const ViaAdministracaoLabels = {
  VIA_ORAL: "Via Oral",
  VIA_TOPICA: "Via Tópica",
  VIA_OCULAR: "Via Ocular",
  VIA_NASAL: "Via Nasal",
  VIA_AURICULAR: "Via Auricular",
  VIA_VAGINAL: "Via Vaginal",
  VIA_RETAL: "Via Retal",
  VIA_SUBCUTANEA: "Via Subcutânea",
  VIA_INJETAVEL: "Via Injetável",
  VIA_INALATORIA: "Via Inalatória",
  VIA_SUBLINGUAL: "Via Sublingual",
  VIA_TRANSDERMICA: "Via Transdérmica",
};

export const TamanhoLabels = {
  PP: "PP",
  XP: "XP",
  P: "P",
  M: "M",
  G: "G",
  XG: "XG",
  EG: "EG",
  XGG: "XGG",
  XXG: "XXG",
  XXXG: "XXXG",
  RN: "RN",
  UNICO: "Único",
  AJUSTAVEL: "Ajustável",
};

export const PrescricaoLabels = {
  SEM_RETENCAO_DE_RECEITA: "Sem Retenção de Receita",
  COM_RETENCAO_DE_RECEITA_BRANCA_C1: "Com Retenção de Receita (Branca C1)",
  COM_RETENCAO_DE_RECEITA_AZUL_B: "Com Retenção de Receita (Azul B)",
  COM_RETENCAO_DE_RECEITA_AMARELA_A: "Com Retenção de Receita (Amarela A)",
  COM_RETENCAO_DE_RECEITA_ANTIMICROBIANO: "Com Retenção de Receita (Antimicrobiano)",
};

export const TipoMedicamentoLabels = {
  GENERICO: "Genérico",
  SIMILAR: "Similar",
  REFERENCIA: "Referência",
  BIOLOGICO: "Biológico",
  FITOTERAPICO: "Fitoterápico",
  HOMEOPATICO: "Homeopático",
  RADIOFARMACO: "Radiofármaco",
  ESPECIFICO: "Específico",
};

export const ClasseTerapeuticaLabels = {
  ANALGESICO: "Analgésico",
  ANTIBIOTICO: "Antibiótico",
  ANTI_INFLAMATORIO: "Anti-inflamatório",
  ANTIFUNGICO: "Antifúngico",
  ANTI_HIPERTENSIVO: "Anti-hipertensivo",
  ANTIDIABETICO: "Antidiabético",
  ANSIOLITICO: "Ansiolítico",
  ANTIDEPRESSIVO: "Antidepressivo",
  ANTICOAGULANTE: "Anticoagulante",
  ANTIALERGICO: "Antialérgico",
  BRONCODILATADOR: "Broncodilatador",
  DIURETICO: "Diurético",
  GASTROPROTETOR: "Gastroprotetor",
  HIPOLIPEMIANTE: "Hipolipemiante",
  HORMONAL: "Hormonal",
  IMUNOSSUPRESSOR: "Imunossupressor",
  VITAMINA_SUPLEMENTO: "Vitamina/Suplemento",
};

export const IndicacaoLabels = {
  DOR_E_FEBRE: "Dor e Febre",
  INFECCOES: "Infecções",
  PRESSAO_ALTA: "Pressão Alta",
  DIABETES: "Diabetes",
  COLESTEROL: "Colesterol",
  ANSIEDADE: "Ansiedade",
  DEPRESSAO: "Depressão",
  ALERGIA: "Alergia",
  ASMA: "Asma",
  PROBLEMAS_GASTRICOS: "Problemas Gástricos",
  PELE_E_CABELO: "Pele e Cabelo",
  VITAMINAS_E_MINERAIS: "Vitaminas e Minerais",
  ORTOPEDIA: "Ortopedia",
  OFTALMOLOGIA: "Oftalmologia",
  DERMATOLOGIA: "Dermatologia",
  PEDIATRIA: "Pediatria",
  GERIATRIA: "Geriatria",
};

// Formas plurais das unidades contaveis. Unidades de medida (ml, g, kg, mg,
// mcg, UI, un/Un) sao invariaveis e ficam de fora: caem no fallback singular.
export const UnidadeEmbalagemLabelsPlural = {
  CAIXA: "Caixas",
  FRASCO: "Frascos",
  BISNAGA: "Bisnagas",
  LATA: "Latas",
  POTE: "Potes",
  BLISTER: "Blisters",
  ENVELOPE: "Envelopes",
  ROLO: "Rolos",
  PACOTE: "Pacotes",
};

export const UnidadeConteudoLabelsPlural = {
  COMPRIMIDO: "comprimidos",
  CAPSULA: "cápsulas",
  DRAGEA: "drágeas",
  SACHE: "sachês",
  PASTILHA: "pastilhas",
};

// Valores de enum usados em regras de negocio (evita magic strings).
export const TipoMedicamento = {
  GENERICO: "GENERICO",
  SIMILAR: "SIMILAR",
  REFERENCIA: "REFERENCIA",
  BIOLOGICO: "BIOLOGICO",
  FITOTERAPICO: "FITOTERAPICO",
  HOMEOPATICO: "HOMEOPATICO",
  RADIOFARMACO: "RADIOFARMACO",
  ESPECIFICO: "ESPECIFICO",
};

// Retorna o label mapeado; se nao mapeado, o valor bruto.
// Retorna null quando vazio ou "OUTRO" (nao devem ser exibidos ao usuario).
export function resolveEnumLabel(map, value) {
  if (value == null || value === "" || value === "OUTRO") return null;
  return map[value] || value;
}

function isPluralQuantity(quantity) {
  const n =
    typeof quantity === "number"
      ? quantity
      : parseFloat(String(quantity).replace(",", "."));
  return Number.isFinite(n) && n > 1;
}

// Retorna o label da unidade no singular ou plural conforme a quantidade.
// null quando o valor for vazio/"OUTRO". Fallback: sem plural mapeado
// (unidade invariavel ou valor desconhecido) mantem o singular.
export function resolveUnitLabel(singularMap, pluralMap, value, quantity) {
  const singular = resolveEnumLabel(singularMap, value);
  if (singular == null) return null;
  if (!isPluralQuantity(quantity)) return singular;
  return (pluralMap && pluralMap[value]) || singular;
}
